module.exports = __webpack_public_path__ + "img/Mental Health Infographic.540dc2e9.png";